import React from 'react'
import enhancer from './enhancers/profileForm'
import { showFieldError, renderValidation } from '../../utils/validations'
import { getExceptionMessage } from '../../utils/exceptions'
import { FormattedMessage } from '@dragonraider5/react-intl'
import { SectionSubTitle } from '../../components/Section'
import FormRow from '../../components/FormFields/FormRow'
import TextField from '../../components/FormFields/TextField'
import Fieldset from '../../components/FormFields/Fieldset'
import FormError from '../../components/FormFields/FormError'
import FormAction from '../../components/FormFields/FormAction'
import CircularProgress from '../../components/CircularProgress'

function ProfileDataForm({
  userProfile,
  values,
  status = {},
  touched,
  errors,
  isSubmitting,
  handleChange,
  handleBlur,
  handleSubmit
}) {
  return (
    <form onSubmit={handleSubmit}>
      <Fieldset>
        <SectionSubTitle as='legend'>Datos de perfil</SectionSubTitle>
        <FormRow>
          <TextField
            name='username'
            label='E-mail'
            value={userProfile.username}
            disabled
          />
          <TextField
            name='nif'
            label='DNI'
            value={userProfile.public_data.nif}
            disabled
          />
        </FormRow>
        <FormRow>
          <TextField
            name='name'
            label='Nombre'
            value={values.name}
            onChange={handleChange}
            onBlur={handleBlur}
            error={showFieldError('name', { errors, touched })}
            help={renderValidation('name', { errors, touched })}
          />
          <TextField
            name='lastname'
            label='Apellidos'
            value={values.lastname}
            onChange={handleChange}
            onBlur={handleBlur}
            error={showFieldError('lastname', { errors, touched })}
            help={renderValidation('lastname', { errors, touched })}
          />
        </FormRow>
        <FormRow>
          <TextField
            name='phone'
            label='Teléfono de contacto'
            value={values.phone}
            onChange={handleChange}
            onBlur={handleBlur}
            error={showFieldError('phone', { errors, touched })}
            help={renderValidation('phone', { errors, touched })}
          />
        </FormRow>
        {status.error && (
          <FormError>
            <FormattedMessage {...getExceptionMessage(status.error)} />
          </FormError>
        )}
        <FormAction type='submit' disabled={isSubmitting}>
          Actualizar mis datos
          {isSubmitting && <CircularProgress size={20} />}
        </FormAction>
      </Fieldset>
    </form>
  )
}

export default enhancer(ProfileDataForm)
